import React, { Component } from 'react';
import { YMaps, Map, Placemark, ZoomControl } from 'react-yandex-maps';

class MapDialog extends Component {

	ymaps = null;
	map = null;
	myPlacemark = null;
	defaultCenter;

	constructor(props) {
		super(props);

		this.state = {
			center: this.props.position,
			myPosition: this.props.position,
			showAddressPanel: true,
			showPlacesPanel: false,
			showAddPlacePanel: false,
			address: "",
			orgs: [],
			orgsYandex: false,
			loading: true,
			buttonDisabled: true,
		};

		this.handlePlaces = this.handlePlaces.bind(this);
		this.handleAddPlace = this.handleAddPlace.bind(this);
		this.handleBack = this.handleBack.bind(this);
		this.handleCenter = this.handleCenter.bind(this);
		this.handleTick = this.handleTick.bind(this);
		this.handleEndMove = this.handleEndMove.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.handleNameKeyUp = this.handleNameKeyUp.bind(this);
	}

	handleDialogClose = e => {
		e.preventDefault();
		this.props.onClose && this.props.onClose(e);
	}

	handleApiAvaliable(ymaps) {
		this.ymaps = ymaps;
		this.map.behaviors.disable('scrollZoom');

		var pixelCenter = this.map.getGlobalPixelCenter(this.props.position);
		var horizontalAspect = this.refs.addresscard.offsetWidth/2;
		pixelCenter = [pixelCenter[0] + horizontalAspect, pixelCenter[1]];
		var geoCenter = this.map.options.get('projection').fromGlobalPixels(pixelCenter, this.map.getZoom());

		this.defaultCenter = geoCenter;

		this.setState({
			center: this.defaultCenter.slice()
		});

		this.showAddress(this.props.position);
	}

	showAddress(position) {
		if (this.ymaps !== null)
			this.ymaps.geocode(position).then(res => {
				let firstGeoObject = res.geoObjects.get(0);

				this.setState((state, props) => ({
					address: firstGeoObject.getAddressLine(),
				}));
			});
	}

	handlePlaces(e) {
		e.preventDefault();
		this.setState({
			showAddressPanel: false,
			showPlacesPanel: true,
		});

		var pixelCenter = this.map.getGlobalPixelCenter(this.state.myPosition);
		var horizontalAspect = this.refs.addresscard.offsetWidth/2;
		pixelCenter = [pixelCenter[0] - horizontalAspect, pixelCenter[1]];
		var geoCenter = this.map.options.get('projection').fromGlobalPixels(pixelCenter, this.map.getZoom());

		this.defaultCenter = geoCenter;

		this.getOrgs(this.state.address);
	}

	handleAddPlace(e) {
		e.preventDefault();

		this.setState({
			showPlacesPanel: false,
			showAddPlacePanel: true,
		});
	}

	handleBack(e) {
		e.preventDefault();

		this.setState({
			showPlacesPanel: true,
			showAddPlacePanel: false,
		});
	}

	getOrgs(address) {
		fetch("https://api.megabitus.com/v1/locations?address="+encodeURI(address), { method: "GET" })
			.then(res => res.json())
			.then(
				(result) => {
					if (result.success) {
						if (typeof result.data.features !== 'undefined')
							this.setState({
								orgs: result.data.features,
								orgsYandex: false,
								loading: false,
							});
					} else {
						this.getYandexOrgs(address);
					}
				},
				(error) => {
					this.setState({
						loading: false,
					});
					console.log(error);
				}
			)
	}

	getYandexOrgs(address) {
		fetch("https://search-maps.yandex.ru/v1/?text="+encodeURI(address)+"&type=biz&lang=ru_RU&apikey=7fc30546-4355-4fee-aaec-64bde0f59736&results=30", { method: "GET" })
			.then(res => res.json())
			.then(
				(result) => {
					if (typeof result.features !== 'undefined') {
						this.setState({
							orgs: result.features,
							orgsYandex: true,
							loading: false,
						});
					} else {
						this.setState({
							loading: false,
						});
					}
				},
				(error) => {
					this.setState({
						loading: false,
					});
					console.log(error);
				}
			);
	}

	saveAddress(index) {
		var place = "Другое";
		var placeLocation = this.state.myPosition;

		if (index === -2)
			place = "Дом";

		if (index === -1)
			place = "Работа";


		if (index >= 0) {
			var orgItem = this.state.orgs[index];
			placeLocation = [orgItem.geometry.coordinates[1], orgItem.geometry.coordinates[0]];
			place = orgItem.properties.name;
		}

		fetch("https://api.megabitus.com/v1/address", {
			method: "POST",
			body: JSON.stringify({
				testId: this.props.id,
				locationUserType: (index >= 0 ? 3 : (index === -3 ? 2 : index + 2)),
				locationUserName: place,
				locationAccuracy: 1,
				locationOrigLatitude: this.state.myPosition[0],
				locationOrigLongitude: this.state.myPosition[1],
				locationLatitude: placeLocation[0],
				locationLongitude: placeLocation[1],
				locationFullAddress: this.state.address,
				locationsYandex: this.state.orgsYandex,
				locations: this.state.orgs,
				location: orgItem,
			})
		})
			.then(res => res.json())
			.then(result => {
				if (result.success) {
					this.props.onMap && this.props.onMap(this.props.id, result.data.poll ? result.data.poll : false)
				} else {
					this.props.onClose && this.props.onClose()
				}
			}, error => {
				this.props.onClose && this.props.onClose()
			})
	}

	handleCenter() {
		this.setState({
			center: this.defaultCenter.slice(),
		});

		if (this.map.getZoom() !== 15)
			this.map.setZoom(15);
	}

	handleTick() {
		if (this.state.showAddressPanel && this.myPlacemark) {
			var state = this.map.action.getCurrentState();
			var horizontalAspect = this.refs.addresscard.offsetWidth/2;
			var pixelCenter = [state.globalPixelCenter[0] - horizontalAspect, state.globalPixelCenter[1]];
			var geoCenter = this.map.options.get('projection').fromGlobalPixels(pixelCenter, state.zoom);
			this.myPlacemark.geometry.setCoordinates(geoCenter);
		}
	}

	handleEndMove() {
		if (this.state.showAddressPanel && this.myPlacemark) {
			var state = this.map.action.getCurrentState();
			var horizontalAspect = this.refs.addresscard.offsetWidth/2;
			var pixelCenter = [state.globalPixelCenter[0] - horizontalAspect, state.globalPixelCenter[1]];
			var geoCenter = this.map.options.get('projection').fromGlobalPixels(pixelCenter, state.zoom);
			this.myPlacemark.geometry.setCoordinates(geoCenter);

			this.showAddress(geoCenter);

			this.setState({
				myPosition: geoCenter,
			});
		}
	}

	handleRestart = e => {
		this.props.onRestart && this.props.onRestart(e);
	}

	distance(position1, position2) {
		var result = 0;
		if (typeof position1 !== 'undefined' && typeof position2 !== 'undefined') {
			var p = 0.017453292519943295;    // Math.PI / 180
			var c = Math.cos;
			var a = 0.5 - c((position2[0] - position1[0]) * p)/2 + c(position1[0] * p) * c(position2[0] * p) * (1 - c((position2[1] - position1[1]) * p))/2;

			result = Math.round( 12742 * Math.asin(Math.sqrt(a)) * 100) * 10; // 2 * R; R = 6371 km
		}

		return result;
	}

	handleNameKeyUp() {
		this.setState({ buttonDisabled: this.refs.placeinput.value.trim().length < 3 });
	}

	handleSave(e) {
		e.preventDefault()

		var place = this.refs.placeinput.value.trim()

		fetch("https://api.megabitus.com/v1/address", {
			method: "POST",
			body: JSON.stringify({
				testId: this.props.id,
				locationUserType: 4,
				locationUserName: place,
				locationAccuracy: 1,
				locationOrigLatitude: this.state.myPosition[0],
				locationOrigLongitude: this.state.myPosition[1],
				locationLatitude: this.state.myPosition[0],
				locationLongitude: this.state.myPosition[1],
				locationFullAddress: this.state.address,
			})
		})
			.then(res => res.json())
			.then(result => {
				if (result.success) {
					this.props.onMap && this.props.onMap(this.props.id, result.data.poll ? result.data.poll : false)
				} else {
					this.props.onClose && this.props.onClose()
				}
			}, error => {
				this.props.onClose && this.props.onClose()
			})

	}

	render() {
		return (
			<div className={"map-dialog"+(this.props.show ? " opened" : "")}>
				<div className="map-dialog__map map-container">
					<YMaps query={{ lang: "ru_RU", apikey: "7095bb7a-7d24-468b-be6e-2a6bbc613861" }}>
						<Map
							width="100%"
							height="100%"
							state={{ center: this.state.center, zoom: 15, yandexMapDisablePoiInteractivity: true }}
							defaultOptions={{ yandexMapDisablePoiInteractivity: true }}
							modules={["geolocation", "geocode"]}
							onLoad={ymaps => this.handleApiAvaliable(ymaps)}
							onActiontick={() => this.handleTick()}
							onActionend={() => this.handleEndMove()}
							instanceRef={ref => this.map = ref}
						>
							<ZoomControl options={{ float: 'right' }} />
							<Placemark
								geometry={this.state.myPosition}
								defaultOptions={{
									iconLayout: 'default#image',
									iconImageHref: '/i/pin-blue.svg',
									iconImageOffset: [-17, -32]
								}}
								instanceRef={ref => this.myPlacemark = ref}
							/>
						</Map>
					</YMaps>
				</div>

				<div className="nav-pills-wrap">
					<ul className="nav nav-pills" id="bwmeterTab" role="tablist">
						<li className="nav-item"><a className="nav-link" href="#bwmeter-start" onClick={this.handleDialogClose}>Скорость</a></li>
						<li className="nav-item"><a className="nav-link active" href="#bwmeter-map" onClick={(e) => e.preventDefault()}>Карта</a></li>
					</ul>
				</div>

				<div ref="addresscard" className="map-dialog__card opened">

					<div className="map-dialog__card__block-wrap">
						<div className={"map-dialog__card__block block-address"+(this.state.showAddressPanel || this.state.showPlacesPanel || this.state.showAddPlacePanel ? " opened" : "")}>
							<div className="map-dialog__card__title">Ваше местоположение</div>
							<div className="map-dialog__card__body">
								<div className="address-label">{this.state.address}</div>
								<div className="address-coords">{Math.round(this.state.myPosition[0] * 1000000) / 1000000}, {Math.round(this.state.myPosition[1] * 1000000) / 1000000}</div>

								<button className="btn btn-confirm btn-megabitus" onClick={this.handlePlaces} disabled={this.state.address.length === 0}>Подтвердить адрес</button>

								<div className="map-dialog__card__hint">Перемещая карту вы можете установить указатель на ваше точное местоположение</div>
							</div>
						</div>

						<div className={"map-dialog__card__block block-places"+(this.state.showPlacesPanel || this.state.showAddPlacePanel ? " opened" : "")}>
							<div className="map-dialog__card__title">Где вы находитесь?</div>
							<div className={"map-dialog__card__body"+(this.state.loading ? " loading" : "")}>
								<ul className="map-dialog__card__list">
									<li className="list-item home" onClick={(e) => { e.preventDefault(); this.saveAddress(-2); }}>
										<span className="list-item__label">Дома</span><span className="list-item__note">0 м</span>
									</li>
									<li className="list-item work" onClick={(e) => { e.preventDefault(); this.saveAddress(-1); }}>
										<span className="list-item__label">На работе</span><span className="list-item__note">0 м</span>
									</li>
									<li className="list-item other" onClick={(e) => { e.preventDefault(); this.saveAddress(-3); }}>
										<span className="list-item__label">Другое</span><span className="list-item__note">0 м</span>
									</li>
									{this.state.orgs.map(
										(org, index) => {
											return (
												<li className="list-item" key={index} onClick={(e) => { e.preventDefault(); this.saveAddress(index); }}>
													<span className="list-item__label">{org.properties.name}</span><span className="list-item__note">{this.distance(this.state.myPosition, [org.geometry.coordinates[1], org.geometry.coordinates[0]])} м</span>
												</li>
											);
										}
									)}
									<li className="list-item add">
										<button className="btn btn-add-place btn-megabitus-link" onClick={this.handleAddPlace}>Добавить новое место</button>
									</li>
								</ul>
							</div>
						</div>

						<div className={"map-dialog__card__block block-add-place"+(this.state.showAddPlacePanel ? " opened" : "")}>
							<div className="map-dialog__card__title"><span className="title__icon" onClick={this.handleBack} dangerouslySetInnerHTML={{__html: '<svg><use xlink:href="/i/i.svg#back"></use></svg>'}}></span>Добавить новое место</div>
							<div className="map-dialog__card__body">
								<div className="address-label">{this.state.address}</div>
								<div className="form-group">
									<input type="text" className="form-control" ref="placeinput" onKeyUp={this.handleNameKeyUp} placeholder="Название места" />
								</div>
								<button className="btn btn-save btn-megabitus" onClick={this.handleSave} disabled={this.state.buttonDisabled}>Добавить место</button>
							</div>
						</div>
					</div>

					<div className="map-dialog__card__footer">
						<div className="indicators">
							<div className="row row0">
								<div className="col col-label">
									{this.props.indicators.provider}
								</div>
								<div className="col col-note">
									{this.props.indicators.type}
								</div>
							</div>
							<div className="row row1">
								<div className="col-sm-6">
									<div className="indicator-name">Download, Мбит/с</div>
									<div className="indicator-value download">{this.props.indicators.download}</div>
								</div>
								<div className="col-sm-6">
									<div className="indicator-name">Upload, Мбит/с</div>
									<div className="indicator-value upload">{this.props.indicators.upload}</div>
								</div>
							</div>
							<div className="row row2">
								<div className="col-sm-4">
									<div className="indicator-name">Ping, мс</div>
									<div className="indicator-value">{this.props.indicators.ping}</div>
								</div>
								<div className="col-sm-4">
									<div className="indicator-name">Jitter, мс</div>
									<div className="indicator-value">{this.props.indicators.jitter}</div>
								</div>
								<div className="col-sm-4">
									<div className="indicator-name">Потери, %</div>
									<div className="indicator-value">{this.props.indicators.losses}</div>
								</div>
							</div>
						</div>
						<button className="btn btn-restart btn-megabitus-link" onClick={this.handleRestart}>Новое тестирование</button>
					</div>
				</div>

				<div className="map-dialog__center map-center" onClick={this.handleCenter} dangerouslySetInnerHTML={{__html: '<svg><use xlink:href="/i/i.svg#geocontrol"></use></svg>'}}></div>
			</div>
		);
	}
}

export default MapDialog;
